import Index from './pages/index'
import Quooker from './pages/quooker'

const routes = [
    {
        path: '/cases',
        name: 'Cases',
        component: Index
    },
    {
        path: '/case/quooker',
        name: 'CaseQuooker',
        component: Quooker
    }
]

export default routes



// WEBPACK FOOTER //
// ./src/app/case/routes.js